import useGetter from "./useGetter";
import useLeagueSeason from "./useLeagueSeason";

export default function usePlayerSeasonStats() {
  const { league, leagueSeason } = useLeagueSeason();

  let leagueUrl = "";
  if (league) leagueUrl = league.getIdOrSlug();

  let season = "";
  if (leagueSeason) season = leagueSeason.obj.season;

  const playerSeasonStatsUrl = `/players/${leagueUrl}/${season}/stats`;

  const enabled = !!league && !!leagueSeason;
  const { data: playerSeasonStatsData, query: playerSeasonStatsQuery } =
    useGetter(playerSeasonStatsUrl, {
      enabled,
      staleTime: 2 * 60 * 60 * 1000,
    });

  return { playerSeasonStatsData, playerSeasonStatsQuery };
}
